import { commonApi } from '../../apis';
import { defineStore } from 'pinia';

export const useTopicStore = defineStore('topicStore', {
  state: (): {
    snapshotId: { [key: string]: number };
    topicDetail: { [key: number]: { isLoading: boolean; retdata: any } };
  } => {
    return {
      snapshotId: {},
      topicDetail: {},
    };
  },
  actions: {
    async getSnapshotId(params: any) {
      const { retdata } = await commonApi.getSnapshotId<any, any>(params);
      if (retdata) {
        this.snapshotId[params.objId] = retdata?.snapshotId as number;
      }
    },
    async getTopicDetail(params: any) {
      if (this.topicDetail[params.topicId]) {
        this.topicDetail[params.topicId].isLoading = true;
      } else {
        this.topicDetail[params.topicId] = { isLoading: true, retdata: {} };
      }

      try {
        const { retdata } = await commonApi.getTopicDetail<any, any>(params);
        if (retdata) {
          if (retdata?.type === 'pk') {
            this.topicDetail[params.topicId].retdata = retdata as any;
          } else {
            const detail = retdata;
            const optionList: any[] =
              detail.optionViewpoints?.map((item: any) => {
                return {
                  value: item.id,
                  isChecked: item.chose,
                  content: item.content,
                  userChoseCount: item.userChoseCount,
                  userChosePercent: Number(item.userChosePercent.replace('%', '')),
                  comments: item.comments,
                };
              }) ?? [];
            this.topicDetail[params.topicId].retdata = {
              id: detail.id,
              attended: detail.attended,
              title: detail.title,
              describe: detail.describe,
              userAttendCount: detail.userAttendCount,
              userMaxChoice: detail.userMaxChoice,
              optionList,
              type: detail.type,
            };
          }
        }
        this.topicDetail[params.topicId].isLoading = false;
      } catch (error) {
        this.topicDetail[params.topicId].isLoading = false;
      }
    },
    setDetail(data: any, id: number) {
      this.topicDetail[id] = data;
    },
  },
});
